import React from "react";
import { Button } from "semantic-ui-react";
import { Modal } from "../../components";

interface Props {
  userToClient: server.dto.UserToClientSmall
  isOpen: boolean
  onClose: () => void
}

const DeactivateAccountModal = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [finishedDeactivating, setFinishedDeactivating] = React.useState<boolean>(false);

  const onDeactivateClick = async () => {
    setIsLoading(true);
    await window.CoreApi.UserToClient.Deactivate({ userToClientId: props.userToClient.userToClientId });
    setIsLoading(false);
    setFinishedDeactivating(true);
    window.location.reload();
  };

  const onClose = () => {
    props.onClose();
    setFinishedDeactivating(false);
  };

  return <Modal width="tiny" title={RESX.SoUser.DeactivateAccount} handleClose={onClose} isOpen={props.isOpen}>
    {!finishedDeactivating && <>
      <div className="grow1">{RESX.GeneralWarnings.AreYouSure}</div>
      <div className="flex justify-end">
        <div><Button loading={isLoading} disabled={isLoading} onClick={onDeactivateClick} color="red">{RESX.SoUser.DeactivateAccount}</Button></div>
      </div>
    </>}
    {finishedDeactivating && <>
      <div className="grow1">
        {RESX.SoUser.AccountDeactivated}
      </div>
    </>}
  </Modal>;
};

export default DeactivateAccountModal;